import React from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

const RadioGenderFragment = ({
  updateRulesAfterEdit,
  editable,
  params,
  direction = "horizontal", // "horizontal" (default) or "vertical"
}) => {
  const handleGenderRadio = (event) => {
    let newRow = structuredClone(params.row);
    newRow.RuleFacts.DisplayGender = event.target.value;
    updateRulesAfterEdit(newRow, params.row);
  };

  return (
    <RadioGroup
      row={direction === "horizontal"}
      value={params.row.RuleFacts.DisplayGender || ""}
      onChange={handleGenderRadio}
      name={"gender-radios_" + params.id}
      sx={{
        "& .MuiFormControlLabel-root": {
          margin: direction === "horizontal" ? "0 8px 0 0" : "0 !important",
          padding: "0 !important",
          minHeight: "20px !important",
        },
        "& .MuiFormControlLabel-label": {
          marginLeft: "5px",
          fontSize: "0.8rem",
          lineHeight: "1",
          padding: 0,
        },
        "& .MuiRadio-root": {
          padding: 0,
          margin: 0,
        },
        padding: 0,
        margin: 0,
      }}
    >
      <FormControlLabel
        value="M"
        disabled={!editable}
        control={<Radio size="small" sx={{ padding: 0, margin: 0 }} />}
        label="Male"
        labelPlacement="end"
      />
      <FormControlLabel
        value="F"
        disabled={!editable}
        control={<Radio size="small" sx={{ padding: 0, margin: 0 }} />}
        label="Female"
        labelPlacement="end"
      />
    </RadioGroup>
  );
};

export default RadioGenderFragment;
